/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-04-28T10:23:25.505
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listBuilding,
	listBuildingInit,
	listBuildingByAuthorizations,
	deleteBuilding
	
} from '@api/storagemanage/Building';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listBuilding({
			state
		}) {
			return new Promise((resolve, reject) => {
				listBuilding(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listBuildingByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listBuildingByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listBuildingInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listBuildingInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteBuilding({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteBuilding({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
